import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=6e8d0ffb&scoped=true&lang=less"

import exportComponent from "/Users/n0ts/Project/Vue/aggregate-search/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e8d0ffb"]])

export default __exports__